












import Vue, { PropType } from "vue";
import _ from "lodash";

export default Vue.extend({
  name: "ReadMore",
  props: {
    limit: { type: Number as PropType<number>, default: 200 },
    text: String as PropType<string>
  },
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    truncatedText(): string | null {
      if (_.isEmpty(this.text)) {
        return null;
      }
      return this.text.substring(0, this.limit);
    }
  }
});
